import React, { forwardRef } from 'react';
import { PaginationProps } from './types';
import Banner from './variants/Banner';
import Dots from './variants/Dots';
import Carousel from './variants/Carousel';
import CarouselS from './variants/CarouselS';
import DefaultS from './variants/DefaultS';
import Default from './variants/Default';
import Alternative from './variants/Alternative';

const PaginationVariants = {
  'default-s': DefaultS,
  alternative: Alternative,
  carousel: Carousel,
  'carousel-s': CarouselS,
  banner: Banner,
  dots: Dots,
};

const Pagination = forwardRef<HTMLDivElement, PaginationProps>(
  ({ type = 'default', onPageChange, currentPage = 1, ...other }, ref) => {
    const onPrev = () => {
      if (typeof onPageChange === 'function') {
        onPageChange(currentPage - 1);
      }
    };
    const onNext = () => {
      if (typeof onPageChange === 'function') {
        onPageChange(currentPage + 1);
      }
    };
    const props = { ref, onPrev, onNext, currentPage, ...other };

    if (type === 'default') {
      return <Default onPageChange={onPageChange} {...props} />;
    }
    const PaginationComponent = PaginationVariants[type];

    return <PaginationComponent {...props} />;
  },
);

export default Pagination;
